export default {
  setTime(state, data) {
    state.time = data;
  },
  setTimes(state, data) {
    state.times = data;
  },
};
